import React from 'react';
import ReactPaginate from 'react-paginate';

class Pagination extends React.Component {
    render() {
        return (
            <ReactPaginate previousLabel={<i className='fa fa-chevron-left'></i>}
                           nextLabel={<i className='fa fa-chevron-right'></i>}
                           breakClassName={"break-me"}
                           pageCount={ this.props.driversPageCount }
                           onPageChange={ this.props.pageChangeHandler }
                           marginPagesDisplayed={2}
                           pageRangeDisplayed={5}
                           containerClassName={"pagination"}
                           subContainerClassName={"pages pagination"}
                           activeClassName={"active"} />
        );
    }
}

export default Pagination;


// WEBPACK FOOTER //
// ./src/components/UI/Pagination.js